import React, { useState } from 'react';
import { useProduct } from '../hooks/useProduct';
import { Button, Table, TableBody, TableCell, TableHead, TableRow, Container, Box, Pagination, Alert, TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export default function Productlist() {
  const { products, page, totalPages, setPage, setSearchQuery, error } = useProduct();
  const [searchText, setSearchText] = useState<string>('');

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handleSearch = () => {
    setSearchQuery(searchText);
    setPage(1);
  };

  return (
    <Container>
      <h2>商品管理</h2>
      <Box display="flex" justifyContent="space-between" mb={5}>
        <TextField
          variant="outlined"
          placeholder="商品名で検索"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSearch();
            }
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Button onClick={handleSearch}>
                  <SearchIcon />
                </Button>
              </InputAdornment>
            ),
          }}
          sx={{ maxHeight: 10 }}
        />
      </Box>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>商品コード</TableCell>
            <TableCell>商品名<br />キーワード</TableCell>
            <TableCell>価格<br />単位</TableCell>
            <TableCell>税計算<br />税区分</TableCell>
            <TableCell>日付区分</TableCell>
            <TableCell>備考</TableCell>
            <TableCell>最終更新日時</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {products.map((product, index) => (
            <TableRow key={index}>
              <TableCell>{product.id}</TableCell>
              <TableCell>{product.name}<br />{product.keyword}</TableCell>
              <TableCell>{product.price}<br />{product.unit}</TableCell>
              <TableCell>{product.tax_flag ? '税込' : '税抜'}<br />{product.tax_rate}%</TableCell>
              <TableCell>{product.day_section === 1 ? '当日' : '翌日以降'}</TableCell>
              <TableCell style={{ maxWidth: '250px', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{product.note}</TableCell>
              <TableCell>
                {product.updated_at?.replace('T', ' ').split('+')[0]}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Box display="flex" justifyContent="center" mt={2}>
        <Pagination count={totalPages} page={page} onChange={handlePageChange} />
      </Box>
    </Container>
  );
}
